import { ReactFC } from 'common/types/ReactFC'
import ImageCard from './base/ImageCard'
import Strings from 'project/localisation'
import { mailroomStrings } from 'common/strings/mailroom-strings'
import useWindowSize from 'components/util/useWindowSize'
import classNames from 'classnames' // we need this to make JSX compile

export type DivertYourPostCardType = {}

const DivertYourPostCard: ReactFC<DivertYourPostCardType> = ({}) => {
  const size = useWindowSize()
  return (
    <ImageCard
      verticalAlign='center'
      className='mailroom-card card-with-vertically-centered-image mt-xxl-60 mb-xxl-54 my-lg-31 mb-xs-70 mb-30 mt-6 mx-xs-0 mx-2'
      theme='gradient-red'
      imageAlt={`${Strings.ourAddress} icon`}
      image={require('public/images/mailroom/mailroom-page-passing-post-desktop.png')}
      imageClass={'vertically-centered-image2 max-w-xxxl-md-70 mt-lg-0'}
      mobileImageProps={{ className: 'm-auto img-mobile-fullwidth2' }}
      mobileImage={require('public/images/mailroom/mailroom-page-passing-post-desktop.png')}
      classNameForCol1={
        'col-lg-6 col-md-7 ps-xxl-26 ps-xl-16 ps-lg-12 ps-8 pe-xxxl-22 pe-xxl-38 pe-lg-18 px-10 py-xxxl-18 py-lg-7 pb-6'
      }
      classNameForCol2={'col-lg-6'}
    >
      <h3
        className={classNames(
          size.isLgOrHigher ? 'fs-fluid-36-80 lh-105' : 'fs-36 lh-105',
          'color-white text-semibold mb-6',
        )}
      >
        {mailroomStrings.stopWastingTime}
      </h3>
      <div
        className='color-white fs-fluid-18-24 text-semibold'
        dangerouslySetInnerHTML={{
          __html: mailroomStrings.stopWastingTimeDescription,
        }}
      />
    </ImageCard>
  )
}

export default DivertYourPostCard
